import { viewportObserver } from '@nova/utils'

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
    this.recommendUrl = this.getAttribute('data-url')
    this.recommendationContainer = this.querySelector(
      '[data-recommendations-container]',
    )
    this.loadRecommendations()
  }

  loadRecommendations() {
    fetch(this.recommendUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        const recommendedContent = html.querySelector(
          '[data-recommendations-container]',
        )
        if (recommendedContent) {
          this.recommendationContainer.innerHTML = recommendedContent.innerHTML
        }

        const resizeObserver = this.recommendationContainer.querySelector(
          '.js-resize-observer',
        )

        const carousel =
          this.recommendationContainer.querySelector('.js-carousel')

        resizeObserver.addEventListener('sl-resize', () => {
          const viewpoint = viewportObserver.getCurrentViewport()
          switch (viewpoint) {
            case 'mobile':
              carousel.setAttribute('slides-per-page', 1.3)
              break
            case 'tablet':
              carousel.setAttribute('slides-per-page', 2.3)
              break
            case 'desktop':
              carousel.setAttribute('slides-per-page', 3.3)
              break
            case 'widescreen':
              carousel.setAttribute('slides-per-page', 3.3)
              break
            default:
              carousel.setAttribute('slides-per-page', 3.3)
              break
          }
        })

        const cards =
          this.recommendationContainer.querySelectorAll('nova-product-card')
        for (const card of cards) {
          const swatchValuesTemplate =
            this.recommendationContainer.querySelector(
              `#swatch-values-json-${card.id}`,
            )
          const sizeValuesTemplate = this.recommendationContainer.querySelector(
            `#size-values-json-${card.id}`,
          )
          const variantsTemplate = this.recommendationContainer.querySelector(
            `#variants-json-${card.id}`,
          )
          const swatchValues = swatchValuesTemplate
            ? JSON.parse(swatchValuesTemplate.content.textContent.trim())
            : []
          const sizeValues = sizeValuesTemplate
            ? JSON.parse(sizeValuesTemplate.content.textContent.trim())
            : []
          const variants = variantsTemplate
            ? JSON.parse(variantsTemplate.content.textContent.trim())
            : []
          card.swatches = swatchValues
          card.sizes = sizeValues
          card.variants = variants
        }
      })
  }
}

customElements.define('nova-product-recommendations', ProductRecommendations)
